import React, { SVGProps } from 'react';

const SvgDollar = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg viewBox='0 0 24 24' className='svg-icon' {...props}>
			<g fill='none' fillRule='evenodd'>
				<path d='M0 0h24v24H0z' />
				<rect
					fill='currentColor'
					opacity={0.3}
					x={11.5}
					y={2}
					width={2}
					height={4}
					rx={1}
				/>
				<rect
					fill='currentColor'
					opacity={0.3}
					x={11.5}
					y={16}
					width={2}
					height={5}
					rx={1}
				/>
				<path
					d='M15.493 8.044a2.933 2.933 0 00-1.093-.846c-.45-.209-.883-.313-1.301-.313-.215 0-.434.019-.655.057-.222.038-.422.11-.599.218a1.48 1.48 0 00-.447.418c-.12.172-.18.39-.18.656 0 .228.047.418.143.57.095.152.234.285.417.399.184.114.403.218.656.314.253.095.538.193.855.294.456.152.931.32 1.425.504a5.33 5.33 0 011.349.731c.405.304.741.68 1.007 1.13.266.45.399 1.01.399 1.682 0 .773-.142 1.44-.428 2.005a3.997 3.997 0 01-1.149 1.396 4.926 4.926 0 01-1.653.817 6.95 6.95 0 01-1.919.266 7.924 7.924 0 01-2.793-.503c-.9-.336-1.647-.814-2.242-1.435l2.128-2.166c.33.405.763.744 1.301 1.017.539.272 1.074.408 1.606.408.24 0 .475-.025.703-.076.228-.05.427-.133.598-.247.172-.114.308-.266.409-.456.101-.19.152-.418.152-.684 0-.253-.063-.469-.19-.646a1.856 1.856 0 00-.542-.485 4.362 4.362 0 00-.873-.399 44.91 44.91 0 00-1.188-.389c-.43-.14-.852-.304-1.263-.494a4.229 4.229 0 01-1.102-.732 3.388 3.388 0 01-.78-1.082c-.196-.425-.294-.941-.294-1.549 0-.747.152-1.387.456-1.919a3.964 3.964 0 011.197-1.311 5.142 5.142 0 011.672-.75 7.581 7.581 0 011.881-.238c.76 0 1.536.14 2.327.418.792.279 1.486.69 2.081 1.235l-2.071 2.185z'
					fill='currentColor'
				/>
			</g>
		</svg>
	);
};

export default SvgDollar;
